import { createStore, applyMiddleware, compose } from "redux";
import { thunk } from "redux-thunk";
import * as cfg from "./config";

import rootReducer from "./reducers"; // <-- no longer a function

import {
  authServiceMiddlewareCreator,
  notificationMiddlewareCreator,
  successAction,
  types,
} from "@authzsvc/api-lib";

const messages = Object.freeze({
  [successAction(types.CREATE_STATIC_GROUP)]: "Group created successfully!",
  [successAction(types.UNSUBSCRIBE_FROM_GROUP)]:
    "Successfully unsubscribed from group",
  [successAction(types.UPDATE_GROUP)]: "Successfully updated group",
  [successAction(types.DELETE_GROUP_BY_ID)]: "Successfully deleted group",
  [successAction(types.ADD_GROUP_MEMBER_IDENTITY)]:
    "Successfully added group member identity",
  [successAction(types.ADD_GROUP_MEMBER_GROUP)]:
    "Successfully added group member group",
  [successAction(types.DELETE_GROUP_MEMBER_GROUP)]:
    "Successfully deleted group member group",
  [successAction(types.DELETE_GROUP_MEMBER_IDENTITY)]:
    "Successfully deleted group member identity",
  [successAction(types.ADD_GROUP_TO_SCOPE)]:
    "Successfully added scope to group",
  [successAction(types.REMOVE_GROUP_FROM_SCOPE)]:
    "Successfully removed scope from group",
});

const middleware = [
  thunk,
  authServiceMiddlewareCreator(cfg),
  notificationMiddlewareCreator(messages),
];

// Enable Redux DevTools extension in development if available.
const composeEnhancers =
  process.env.NODE_ENV !== "production" &&
  typeof window !== "undefined" &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const composedEnhancers = composeEnhancers(applyMiddleware(...middleware));

export default createStore(rootReducer, {}, composedEnhancers);
